<script>
    import { allProjectFields, allTemplateFields } from "../../Participaid.svelte";

    import LoadingSpinner from "../LoadingSpinner.svelte";
    import Reporter from "../../lib/error.js";

    import Select, {Option} from '@smui/select';
    import Icon from '@smui/select/icon/index';
    import HelperText from '@smui/select/helper-text/index';
    import Button, {Group, GroupItem, Label} from '@smui/button';

    export let selectedId = "NONE";
    export let selected;
    export let disabled;
    export let label = "Field input type";
    export let help = `
        The type of the value argument as entered by the contributor.
        When choosing 'Currency', a single field is presented to the contributor when registering a new contribution
        accepting a monetary value. The contributor is expected to calculate the monetary value of his/her contribution
        himself, according to the requirements as specified by the Project Owner (you). When choosing 'Time', the contributor
        gets presented an input field accepting a time duration.
    `;

    // TODO: get from API
    let options = [
        "TIME",
        "CURRENCY"
    ];

</script>

<Select enhanced variant="outlined" withLeadingIcon bind:value={selectedId} {label} {disabled} style="width: 100%">
    <span slot="icon"><Icon class="material-icons">work</Icon></span>
    {#each options as option}
        <Option
                value={option}
                selected={selectedId.toUpperCase() == option}>
        {option.toLowerCase().replace("_", " ")}
        </Option>
    {/each}
</Select>

{#if help}
    <HelperText id="helper-text-persistent-c" persistent>{help}</HelperText>
{/if}

<style>
    option {
        text-transform: capitalize;
    }
</style>